import axios from 'axios';
import { create } from 'apisauce';
import { getApiUrl } from 'utils/utils';
import { integrations } from 'config';

const axiosInstance = axios.create({
  baseURL: getApiUrl(),
  headers: {
    'Content-Type': 'application/json',
    'Api-Target-Version': integrations.apiTargetVersion,
  },
});

axiosInstance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const api = create({ axiosInstance });

const apiAxiosInstance = api.axiosInstance;

const setWithCredentials = (value) => {
  apiAxiosInstance.defaults.withCredentials = value;
};

export { api, apiAxiosInstance, setWithCredentials };
